<template>

  <div>
    <Popup v-model="showDialog">
      <template #content>
        <div id="add_to_playlist_page">
            <div class="inner">

                <h3>הוספת השיר - "{{item.name}}" לפלייליסט:</h3>

                <ul>
                  <li v-for="playlist in playlistsComp" :key="playlist.id"><a @click="add(playlist.id)" v-text="playlist.name"></a></li>
                  <li><a @click="showAdd=true">+ הוספת פלייליסט חדש</a></li>
                </ul>

            </div>

            <form v-if="showAdd" class="add_new" @submit.prevent="savePlaylist()">
              <input class="inp" v-model="addPlaylistName" placeholder="שם הפלייליסט:">
              <input type="submit" value="הוספה" class="btn">
            </form>
        </div>
      </template>

      <template #actions>
        <a class="md-primary" @click="showDialog=false">סגירה</a> 
      </template>
    </Popup>

  </div>
</template>

<script>


export default {  
    
  props: ["playlists"],
    data(){
        return {
          item: false,
          addPlaylistName: '',
          showAdd:false,
          showDialog: false
           // open:false,
        };
    },

    mounted(){
      this.$bus.$on('open_playlist_panel', (item) => { this.item = item; this.showDialog=true; });
    },

    computed:{
        playlistsComp()
        {
          let ret = [];
          for (let i in this.playlists)
          {
            if (this.playlists[i].id > 0) ret.push(this.playlists[i]);
          }

          return ret;
        }
    },

    methods: {
      add(playlist_id){
        this.api({ action: 'playlist/add_to', data: { playlist: playlist_id, item_id: this.item.id } }, () =>{ 
          this.showDialog=false
          this.alert('השיר נוסף לפלייליסט');
          this.$emit('close')
        });
      },
      
    savePlaylist(){
      this.api({ action: 'playlist/add', data: { name: this.addPlaylistName } }, (data) =>{ 
        //this.$emit('addPlaylist', data.data, this.addPlaylistName);
        //this.alert('הפלייליסט ' + this.addPlaylistName + ' נשמר');

        this.add(data.data);
      });
    }
    }
}
</script>

<style lang="scss" scoped>
#add_to_playlist_page{ text-align: center; padding:40px; overflow-y:auto;

    h3 { margin-bottom: 20px; }

    ul { 
      li a { display: block; cursor: pointer; padding:  15px; margin-bottom: 10px; background: #eee; color: #000; }
    }

    .add_new { display: flex;
      .inp { height: 40px; width: 100%; border-radius: 40px; padding: 0 25px; border:1px solid rgb(122, 122, 122); font-size: 20px; }
      .input.btn { }
    }
}
</style>